export function getDebounce() {
  const debounceTime = 300;
  let debounceTimer = setTimeout(() => {}, 0);
  return (fn: () => void, delay = debounceTime) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, delay);
  };
}
